import * as React from 'react';

export function ChevronUpIcon({
  width = 24,
  height = 24,
  color = 'currentColor',
}) {
  return (
    <svg
      height={height}
      width={width}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21 16L12 7L3 16" stroke={color} strokeWidth="2" />
    </svg>
  );
}
